import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

let host = window.location.host;
let protocol = window.location.protocol;
let parts = host.split(".");
let subdomain = "";
let isNOTSubDomain = false;
// If we get more than 3 parts, then we have a subdomain
// INFO: This could be 4, if you have a co.uk TLD or something like that.
if (parts.length >= 3) {
    subdomain = parts[0];
    // Remove the subdomain from the parts list

    parts.splice(0, 1);
    // Set the location to the new url

    //window.location = protocol + "//" + parts.join(".") + "/" + subdomain;
}
else {
    console.log(host);
    isNOTSubDomain = true;
    console.log(isNOTSubDomain);
}

ReactDOM.render(
<BrowserRouter>
<App />
</BrowserRouter>, rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
